import { render, staticRenderFns } from "./GamePlayModal.vue?vue&type=template&id=36c2bc7e&scoped=true&"
import script from "./GamePlayModal.vue?vue&type=script&lang=js&"
export * from "./GamePlayModal.vue?vue&type=script&lang=js&"
import style0 from "./GamePlayModal.vue?vue&type=style&index=0&id=36c2bc7e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c2bc7e",
  null
  
)

export default component.exports